import { TextareaHTMLAttributes } from "react";
import "./style.css";

interface YudlTextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    containerStyle?: string;
    invalidFeedback?: string;
}

const YudlTextArea = ({ label, invalidFeedback, containerStyle = "", ...props }: YudlTextAreaProps) => {
    return (
        <div className={`yuld-textarea-control my-3 ${containerStyle}`}>
            {label && <label className="text-theme yudl-label">{label}</label>}
            <textarea className="yudl-textarea form-control w-100" {...props} />
            <small className="invalid-feedback">{invalidFeedback}</small>
        </div>
    );
};

export default YudlTextArea;
